import { beginnerGames, categoryStats } from "@/mocks/erogeData";

export default function Beginner() {
  const go = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="beginner" className="py-14 md:py-20 px-4 md:px-8 bg-background-100/50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-flex items-center gap-1.5 text-accent-500 text-sm mb-2">
              <i className="ri-compass-3-line" />
              BEGINNER
            </span>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 tracking-wide">
              工口游戏入门推荐
            </h2>
            <p className="mt-3 text-sm text-foreground-600 max-w-xl leading-7">
              第一次接触不知道选哪款？这里为你挑选了几部流程适中、节奏友好、口碑扎实的入门作品，帮你顺利迈出第一步。
            </p>
          </div>
          <button
            onClick={() => go("#ranking")}
            className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
          >
            看完整排行榜 <i className="ri-arrow-right-line" />
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {beginnerGames.map((g) => (
            <article
              key={g.id}
              className="group rounded-xl bg-background-200/40 border border-background-200/60 overflow-hidden hover:border-primary-500/40 transition-colors cursor-pointer"
              onClick={() => go("#ranking")}
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={g.image}
                  alt={`${g.title} 工口游戏入门推荐封面图`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-foreground-950 text-xs font-medium">
                  {g.type}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-start justify-between gap-2 mb-2">
                  <h3 className="font-heading text-base md:text-lg text-foreground-950">{g.title}</h3>
                  <span className="inline-flex items-center gap-1 text-accent-400 text-sm font-medium whitespace-nowrap">
                    <i className="ri-star-fill" />{g.rating}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mb-3">{g.category} · {g.year} · {g.studio}</p>
                <p className="text-xs leading-6 text-foreground-600 line-clamp-3">{g.desc}</p>
                <div className="flex flex-wrap gap-1.5 mt-3">
                  {g.tags.map((t) => (
                    <span key={t} className="px-2 py-0.5 rounded-md bg-secondary-500/15 text-secondary-400 text-[11px]">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-12 rounded-xl bg-background-200/40 border border-background-200/60 p-5 md:p-6">
          <h3 className="font-heading text-lg md:text-xl text-foreground-950 mb-5 flex items-center gap-2">
            <i className="ri-apps-2-line text-primary-500" />
            热门题材分类
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
            {categoryStats.map((c) => (
              <div
                key={c.name}
                className="flex flex-col items-center gap-2 rounded-lg bg-background-100/70 border border-background-200/50 px-3 py-4 hover:border-accent-500/40 transition-colors cursor-pointer"
                onClick={() => go("#ranking")}
              >
                <span className="w-9 h-9 rounded-full bg-accent-500/15 flex items-center justify-center">
                  <i className={`${c.icon} text-accent-500 text-lg`} />
                </span>
                <span className="text-sm text-foreground-800">{c.name}</span>
                <span className="text-xs text-foreground-500">{c.count} 部作品</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}